import $ = require('jquery');

class ContactForm {
    Name: string;
    Email: string;
    TextMessage: string;
    Phone: string;
    Company: string;

    constructor(name: any, email: any, phone: any, company:any, message: any,) {
        this.Name = name;
        this.Email = email;
        this.Phone = phone;
        this.Company = company;
        this.TextMessage = message;
    }

    Send() {
        $.ajax({
            type: 'POST',
            url: "/umbraco/api/Contact/SendContactForm/",
            data: JSON.stringify(this),
            contentType: 'application/json; charset=utf-8',
            dataType: 'json'
        }).done(function (data:any) {
            $("#contactFormSubmit").prop("disabled", false);
            if (data == true) {
                $("#contactForm").remove();
                $(".valid").addClass("show");
                $(".invalid").removeClass("show");
            }
            else {
                $(".invalid").addClass("show");
                $(".valid").removeClass("show");
            }
        }).fail(function () {
            $(".invalid").addClass("show");
        });
    }
}


function initContactForm() {
    console.log("contact form loaded");

    $("#contactFormSubmit").click(function () {
        $("#contactFormSubmit").prop("disabled", true);
        var formSpam = $("#name-email-url").val();
        event.preventDefault()
        
        if (formSpam == null) {
            var contactForm = new ContactForm($("#formName").val(), $("#formEmail").val(), $("#formPhone").val(), $("#formCompany").val(), $("#formMessage").val());
            contactForm.Send();
        }
    });
}

export = initContactForm;


// WEBPACK FOOTER //
// ./ToxicVentures.Umbraco/Content/Ts/contact-form.ts